const LOGIN = "/login";
const REGISTER = "/register";
const FORGOT_PASSWORD = "/forgot-password";
const PRIVACY_POLICY_PUBLIC = "/privacy-policy";
const CONTACT = "/contact";
const TERMS_CONDITIONS_PUBLIC = "/terms";
const LANDING_PAGE = "/";
const SL_HOME = "/slno";
const MODULES = "/modules";
const COMPANIES = "/companies";
const SUBSCRIPTIONS = "/subscriptions";
const COMPANY_DETAILS = `${COMPANIES}/:companyId`;
const COMPANY_USERS = `${COMPANIES}/:companyId/users`;
const BILLGATE_HOME = "/billgate";
const CHART_OF_ACCOUNTS = `${BILLGATE_HOME}/chart-of-accounts`;
const VOUCHER_REGISTER = `${BILLGATE_HOME}/voucher-register`;
const CREDIT_VOUCHER_MENU = `${BILLGATE_HOME}/credit-voucher`;
const CREDIT_VOUCHER = `${CREDIT_VOUCHER_MENU}/:voucherId?`;
const DEBIT_VOUCHER_MENU = `${BILLGATE_HOME}/debit-voucher`;
const DEBIT_VOUCHER = `${DEBIT_VOUCHER_MENU}/:voucherId?`;
const JOURNAL_VOUCHER_MENU = `${BILLGATE_HOME}/journal-voucher`;
const JOURNAL_VOUCHER = `${JOURNAL_VOUCHER_MENU}/:voucherId?`;
const REPORTS = `${BILLGATE_HOME}/reports`;
const BILLGATE_SETTINGS = `${BILLGATE_HOME}/settings`;
const NOTIFICATIONS = `${BILLGATE_HOME}/notifications`;
const TRANSLATION = `${BILLGATE_HOME}/translations`;
const PRIVACY_POLICY = `${BILLGATE_HOME}/privacy-policy`;
const TERMS_CONDITIONS = `${BILLGATE_HOME}/terms-conditions`;
const ABOUT = `${BILLGATE_HOME}/about`;
const PROFILE = `${SL_HOME}/my-profile`;
const SERVICE_CENTERS = `${SL_HOME}/service-centers`;
const SERVICE_TYPES = `${SL_HOME}/service-types`;
const OFF_DAYS = `${SL_HOME}/off-days`;
const SERVICE_MEN = `${SL_HOME}/service-men`;
const SERIALNO_SETTINGS = `${SL_HOME}/settings`;
const CUSTOMER_SERVICES = `${SL_HOME}/my-services`;
const DEVELOPER_COMPANIES = `${SL_HOME}/companies`;
const DEVELOPER_LOCATIONS = `${SL_HOME}/locations`;

const ROUTES = {
  PATHS: {
    BILLGATE_HOME,
    LANDING_PAGE,
    MODULES,
    SL_HOME,
    COMPANIES,
    SUBSCRIPTIONS,
    COMPANY_DETAILS,
    COMPANY_USERS,
    CHART_OF_ACCOUNTS,
    VOUCHER_REGISTER,
    CREDIT_VOUCHER_MENU,
    CREDIT_VOUCHER,
    DEBIT_VOUCHER_MENU,
    DEBIT_VOUCHER,
    JOURNAL_VOUCHER_MENU,
    JOURNAL_VOUCHER,
    REPORTS,
    LOGIN,
    BILLGATE_SETTINGS,
    NOTIFICATIONS,
    REGISTER,
    PROFILE,
    FORGOT_PASSWORD,
    TRANSLATION,
    PRIVACY_POLICY,
    PRIVACY_POLICY_PUBLIC,
    CONTACT,
    TERMS_CONDITIONS,
    TERMS_CONDITIONS_PUBLIC,
    ABOUT,
    SERVICE_CENTERS,
    SERVICE_TYPES,
    SERVICE_MEN,
    OFF_DAYS,
    SERIALNO_SETTINGS,
    CUSTOMER_SERVICES,
    DEVELOPER_COMPANIES,
    DEVELOPER_LOCATIONS
  },
};

export default ROUTES;
